//reembolso raizen

import React, { useState, useEffect, useRef } from "react";
import { Panel } from "primereact/panel";

import {
  locale,
  addLocale,
} from "primereact/api";

import ToLogin from "../../../components/misc/Redirect/ToLogin";
import { IComercioRequest } from "../../../interfaces/IComercioRequest";
import { IReembolsosComerciosRaizenRequest } from "../../../interfaces/IReembolsosComerciosRaizenRequest";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { isNull } from "util";
import TransaccionesAsociadas from "./TransaccionesAsociadas";
import { useRCContext } from "../context/reembolsoComercio.context";
import {
  obtenerReembolsosComerciosRaizen,
   usuariosObtenerComerciosRaizen,
} from "../services/reembolso.service";
import HeaderShellFlota from "./HeaderShellFlota";
import {
  SUCCESS_COMERCIOS_RAIZEN,
  SUCCESS_RC_RAIZEN,
} from "../utilities/constant";

import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";

interface IState {
  loadingReembolsos: boolean;
  selectedComercio: any;
  filteredComercios: any;
  fechaDesde: any;
  fechaHasta: any;
  listaReembolsos: any;
  rId: any;
  minDateFechaDDE: any;
  minDateFechaHTA: any;
  maxDateFechaDDE: any;
  maxDateFechaHTA: any;
  yearRangeDDE: any;
  yearRangeHTA: any;
}
interface IComercio {
  comercioId: number;
  cuit: string;
  nombreFantasia: string;
  razonSocial: string;
}

const ReembolsoComercio = () => {
  const { stateComercio, setStateComercio } = useRCContext();

  const [state, setState] = useState<IState>({
    loadingReembolsos: false,
    selectedComercio: null,
    filteredComercios: null,
    fechaDesde: null,
    fechaHasta: null,
    listaReembolsos: [],
    rId: 0,
    minDateFechaDDE: new Date(2021, 8, 1),
    minDateFechaHTA: new Date(2021, 8, 31),
    maxDateFechaDDE: new Date(2030, 10, 1),
    maxDateFechaHTA: new Date(2030, 11, 31),
    yearRangeDDE: "2021:2030",
    yearRangeHTA: "2021:2030",
  });
  const [redirectLogin, setRedirectLogin] = useState({
    redirectLogin: false,
    url: "",
  });
  const [comercios, setComercios] = useState([]);
  const [loadingComercios, setLoadingComercios] = useState(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [dNoneDDE, setDNoneDDE] = useState<string>("d-none");
  const [dNoneHTA, setDNoneHTA] = useState("d-none");
  const gl = useRef<Toast>(null);
  const cal = useRef<Calendar>(null);
  useEffect(() => {
    callback_comercios();
  }, []);

  //#region "callbacks"
  //trae la lista de cupones con las tra del comercio
  const callback_reembolsosComerciosRaizen = async () => {
    let postData: IReembolsosComerciosRaizenRequest = {
      redId: state.selectedComercio.comercioId,
      vrfReceiveDateFrom: state.fechaDesde,
      vrfReceiveDateTo: state.fechaHasta,
    };

    const {data,status} = await obtenerReembolsosComerciosRaizen(postData);
    if (status === 200) {
      if (
        data.nologin != undefined &&
        data.nologin.indexOf("http") > -1
      ) {
        setRedirectLogin({ redirectLogin: true, url: data.nologin });
      } else if (data.success) {
        let listaReembolsos = data.reembolsosComerciosRaizen;
        setState({
          ...state,
          listaReembolsos: data.reembolsosComerciosRaizen,
          loadingReembolsos: false,
        });
      } else {
        setState({
          ...state,
          listaReembolsos: [],
          loadingReembolsos: false,
        });
      }
    }
  };

  //traer los comercios asociados al USER
  const callback_comercios = async () => {
    let postData: IComercioRequest = {
      usuario: "comercio",
    };
    let {data,status} = await usuariosObtenerComerciosRaizen(postData);
    if (status === 200) {
      if (
        data.nologin != undefined &&
        data.nologin.indexOf("http") > -1
      ) {
        setRedirectLogin({ redirectLogin: true, url: data.nologin });
      } else if (data.success) {
        let comercios = data.comercios.map((item: IComercio) => {
          return {
            comercioId: item.comercioId,
            label: item.comercioId + "-" + item.razonSocial,
          };
        });

        setComercios(comercios);
        setLoadingComercios(false);
      }else{
        setComercios([]);
        setLoadingComercios(false);
      }
    }
  };
  //#endregion "callbacks"

  //#region "metodosCupones"
  const traerCupones = () => {
    if (!state.selectedComercio || !state.fechaDesde || !state.fechaHasta) {
      setVisible(true);
    } else {
      if (validarFechas()) {
        setState({
          ...state,
          loadingReembolsos: true,
          rId: state.selectedComercio.comercioId,
        });
        setDNoneHTA("d-none");
        setDNoneDDE("d-none");
        callback_reembolsosComerciosRaizen();
      }
    }
  };

  const limpiarCupones = () => {
    setState({
      ...state,
      listaReembolsos: [],
      selectedComercio: null,
      fechaDesde: null,
      fechaHasta: null,
    });
  };
  //#endregion "metodosCupones"
  //#region "metodosCalendars"
  const validarFechas = () => {
    var fechaDesde = new Date();
    var fechaHasta = new Date();
    var mesDDE = 1;
    var anioDDE = 1;
    var mesHTA = 1;
    var anioHTA = 1;
    var rta = false;

    if (state.fechaDesde) {
      fechaDesde = new Date(state.fechaDesde);
      mesDDE = fechaDesde.getMonth();
      anioDDE = fechaDesde.getFullYear();
      if (fechaDesde.getTime() >= state.minDateFechaDDE.getTime()) {
        rta = true;
        setDNoneDDE("d-none");
      }
    }
    if (state.fechaHasta) {
      fechaHasta = new Date(state.fechaHasta);
      mesHTA = fechaHasta.getMonth();
      anioHTA = fechaHasta.getFullYear();

      var transcurso = Math.round(
        (fechaHasta.getTime() - fechaDesde.getTime()) / (1000 * 60 * 60 * 24)
      );

      if (fechaDesde.getTime() < state.minDateFechaDDE.getTime()) {
        rta = false;
        setDNoneDDE("");
      } else {
        if (transcurso > 0 && transcurso <= 90) {
          rta = true;
          setDNoneHTA("d-none");
        } else {
          rta = false;
          setDNoneHTA("");
        }
      }
    }
    return rta;
  };

  //#endregion "metodosCalendars"
  //#region "onChanges"
  const onComercioChange = (e: any) => {
    var a = e;
    setState({ ...state, selectedComercio: e.value });
  };

  const onChangeFechaDesde = (e: any) => {
    var fechaDesde = null;
    var min = new Date(state.minDateFechaDDE);
    if (e) {
      var dia = 1;
      var mes = e.getMonth();
      var anio = e.getFullYear();
      fechaDesde = new Date(anio, mes, dia);

      if (fechaDesde.getTime() >= min.getTime()) {
        setDNoneDDE("d-none");
      } else {
        setDNoneDDE("");
      }
      setState({ ...state, fechaDesde });
    } else {
      setState({ ...state, fechaHasta: null, fechaDesde });
    }
    validarFechas();
  };
  /*
    showError = (severity: string, summary: string, detail: string) => {
        this.growl.show({ severity: severity, summary: summary, detail: detail });
    }
*/
  const onChangeFechaHasta = (e: any) => {
    var fechaHasta = null;

    if (e) {
      var fecha = new Date(e);

      var dia = 0;
      var mes = fecha.getMonth();
      var anio = fecha.getFullYear();

      switch (mes) {
        case 11:
          mes = 0;
          anio = anio + 1;
          break;

        default:
          mes = mes + 1;
          break;
      }
      fechaHasta = new Date(anio, mes, dia);
      var min = new Date(state.fechaDesde);
      var transcurso = Math.round(
        (fechaHasta.getTime() - min.getTime()) / (1000 * 60 * 60 * 24)
      );
      if (
        transcurso >= 0 &&
        transcurso <= 90 &&
        fechaHasta.getTime() >= state.minDateFechaDDE.getTime()
      ) {
        setDNoneHTA("d-none");
      } else {
        setDNoneHTA("");
      }
    }
    setState({ ...state, fechaHasta });
  };
  //#endregion "onChanges"

  const renderMensaje = () => {
    var mensaje = [
      !state.selectedComercio ? "Se debe seleccionar comercio " : "",
      !state.fechaDesde ? "Se debe seleccionar Fecha desde" : "",
      !state.fechaHasta ? "Se debe seleccionar Fecha Hasta" : "",
    ];
    return (
      <Dialog
        header="Por favor verificar:"
        className="rounded-pill"
        visible={visible}
        style={{ width: "50vw" }}
        modal={true}
        onHide={() => setVisible(false)}
      >
        <ul>
          <li className={state.selectedComercio ? "d-none" : ""}>
            {" "}
            {mensaje[0]}
          </li>
          <li className={state.fechaDesde ? "d-none" : ""}> {mensaje[1]}</li>
          <li className={state.fechaHasta ? "d-none" : ""}> {mensaje[2]}</li>
        </ul>
      </Dialog>
    );
  };
  //growl: any;
  //calDDE: any;
  const handleLoading = () => {
    if (state.loadingReembolsos) {
      return (
        <div className="loading mt-5">
          <span className="spinner-border" role="status"></span>
          <p className="d-block mt-3">Cargando</p>
        </div>
      );
    }
  };

  if (redirectLogin.redirectLogin) {
    return <ToLogin url={redirectLogin.url} />;
  } else if (!loadingComercios) {
    //console.log('this.state.loadingComercios', this.state.loadingComercios);
    addLocale("es", {
      firstDayOfWeek: 1,
      dayNames: [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ],
      monthNamesShort: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic",
      ],
      today: "este mes",
      clear: "x",
    });
    //locale('es');
    return (
      <div>
        <main className="layout-main dashboard">
          <Toast ref={gl} />
          {renderMensaje()}
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
              <Panel
                headerTemplate={
                  <HeaderShellFlota
                    traerCupones={traerCupones}
                    limpiarCupones={limpiarCupones}
                  />
                }
              >
                <div className="row">
                  <div
                    className="col-sm-12 col-md-12 col-lg-6  mt-4 "
                    title="Seleccionar Empresa"
                  >
                    <span className="p-float-label mb-3">
                      <label htmlFor="ddlComercios">{"Comercio:"}</label>
                    </span>
                    <Dropdown
                      id="ddlComercios"
                      className="text-wrap"
                      value={state.selectedComercio}
                      options={comercios}
                      onChange={onComercioChange}
                      optionLabel="label"
                      style={{ width: "36em" }}
                      filter={true}
                      filterPlaceholder="Selecione Comercio..."
                      filterBy="label"
                      showClear={true}
                    />
                  </div>
                  <div
                    className="col-sm-12 col-md-12 col-lg-3 mt-4 "
                    title="Seleccionar Mes desde (mayor o igual a sep/2021)"
                  >
                    <span className="p-float-label mb-3">
                      <label htmlFor="calFechaDDE">
                        {"Mes presentación desde"}
                      </label>
                    </span>
                    <Calendar
                      ref={cal}
                      id="calFechaDDE"
                      value={state.fechaDesde}
                      onChange={(e) => onChangeFechaDesde(e.value)}
                      locale={"es"}
                      dateFormat="M/yy"
                      monthNavigator={true}
                      yearNavigator={true}
                      yearRange="2021:2030"
                      showButtonBar={true}
                      showIcon={true}
                      view="month"
                      readOnlyInput={true}
                    />
                    <span className="p-float-label mb-3 text-danger">
                      <small className={dNoneDDE}>
                        {" "}
                        *-Se debe asignar mes-desde posterior a sep/2021
                      </small>
                    </span>
                  </div>
                  <div
                    className="col-sm-12 col-md-12 col-lg-3  mt-4 ml-0"
                    title="Seleccionar mes hasta (el rango debe ser igual o menor a tres meses)"
                  >
                    <span className="p-float-label mb-3">
                      <label htmlFor="calFechaHTA">
                        {"Mes presentación hasta"}
                      </label>
                    </span>
                    <Calendar
                      id="calFechaHTA"
                      value={state.fechaDesde ? state.fechaHasta : null}
                      onChange={(e) => onChangeFechaHasta(e.value)}
                      locale={"es"}
                      dateFormat="M/yy"
                      monthNavigator={true}
                      yearNavigator={true}
                      yearRange="2021:2030"
                      showButtonBar={true}
                      showIcon={true}
                      view="month"
                      readOnlyInput={true}
                      disabled={state.fechaDesde != null ? false : true}
                    />
                    <span className="p-float-label mb-3 text-danger">
                      <small className={dNoneHTA}>
                        {" "}
                        *-El rango de meses debe mayor a uno o menor a tres
                        meses
                      </small>
                    </span>
                  </div>
                </div>
              </Panel>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
              {!state.loadingReembolsos ? (
                <TransaccionesAsociadas
                  listaCupon={state.listaReembolsos}
                  redId={state.rId}
                />
              ) : (
                handleLoading()
              )}
            </div>
          </div>
        </main>
      </div>
    );
  } else
    return (
      <div className="loading">
        <span className="spinner-border" role="status"></span>
        <p className="d-block mt-3">Cargando</p>
      </div>
    );
};

export default ReembolsoComercio;
